import type { Character } from "../types/character";
import { ALL_CHARACTERS } from "../types/character";

export function createCoinPool(
  coinsPerCharacter: number,
): readonly Character[] {
  const pool: Character[] = [];
  for (const character of ALL_CHARACTERS) {
    for (let i = 0; i < coinsPerCharacter; i++) {
      pool.push(character);
    }
  }
  return pool;
}

// Few-player (≤5) variant: extra tokens added to the pool after setup so 3–5
// player games have enough to draw. 3 players: +2/char (10); 4–5: +3/char (15).
export function createFewPlayerAdditions(
  playerCount: number,
): readonly Character[] {
  if (playerCount > 5) return [];
  return createCoinPool(playerCount === 3 ? 2 : 3);
}

export function shufflePool(
  pool: readonly Character[],
  randomFn: () => number = Math.random,
): readonly Character[] {
  const result = [...pool];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(randomFn() * (i + 1));
    const temp = result[i];
    result[i] = result[j];
    result[j] = temp;
  }
  return result;
}

export function drawCoins(
  pool: readonly Character[],
  count: number,
): {
  readonly drawn: readonly Character[];
  readonly remaining: readonly Character[];
} {
  const actualCount = Math.min(count, pool.length);
  return {
    drawn: pool.slice(0, actualCount),
    remaining: pool.slice(actualCount),
  };
}
